import React from "react";

import { Box, Text } from "@chakra-ui/react";
import { RouteItem } from "./route-item";

export const About = () => (
  <RouteItem title="About">
    <Box>
      <Text>
        This application enables users to explore and download tiled dataset.
        New layers are added as they are received, processed, and archived.  All
        application development uses a combination of HTML5, CSS3, and
        Javascript. The ArcGIS API for JavaScript is used along with the ReactJS
        Javascript framework.
      </Text>
    </Box>
  </RouteItem>
);
